import React, { useEffect, useState } from 'react';
import styles from "../../assets/stylesheets/sass/Inputfield.module.scss";

export default function Inputfield({defaultValue, type, characterCount, maxCharacters, leadingIcon, trailingIcon, helperText, placeholder, onChange, autofocus, value, disabled, error, active, disableMarginTop}){
    const [lengthInput, setlengthInput] = useState(0);
    const [maxChar, setmaxChar] = useState(0);
    const [charCount, setcharCount] = useState(false);

    const handleInputOnChange = (e) =>{
        setlengthInput(e.currentTarget.value.length)
        onChange(e);
    }

    useEffect(()=>{
        setcharCount(characterCount);
        setmaxChar(maxCharacters);

        if(!characterCount && maxCharacters) {
            setcharCount(true)
        }
        else if(!maxCharacters && characterCount){
            setmaxChar(20)
        }

    }, [maxCharacters, characterCount])
  
    return (
    <>
      <div className={styles.inputfield_container}>
        <div className={error ? styles.formGroupError : (active ? styles.formGroupActive : styles.formGroup)}>
            {leadingIcon && <i className={styles.leadingIcon}>{leadingIcon}</i>}
            <div className={`${styles.inputDiv}`}>
                <input defaultValue={defaultValue} disabled={disabled} value={value} maxLength={maxChar} onChange={(e)=>handleInputOnChange(e)} type={type ? type : "text"} id={type+placeholder} className={styles.formField} placeholder={placeholder} autoFocus={autofocus}/>
                <label htmlFor={type+placeholder} className={error ? styles.formLabelError : (active ? styles.formLabelActive : styles.formLabel)}>{placeholder}</label>
            </div>
            {/* {trailingIcon && <i className={styles.trailingIcon}>{trailingIcon}</i>} */}
            {trailingIcon && <img className={styles.trailingIcon} src={trailingIcon} alt="trailing icon"/>}
        </div>
        <div className={styles.inputfield_bottom}>
            <div>
                {helperText && <p className={styles.helper_text}>{helperText}</p>}
            </div>
            <div style={{minWidth:"fit-content"}}>
                {charCount && <p className={styles.character_count}>{lengthInput} / {maxChar}</p>}
            </div>
        </div>
        </div>
    </>
  )
}